// eslint:disable variable-name
import * as React from 'react';
import { Button, ButtonProps } from './button';

import styles from './button-call-to-action.scss';

export const ButtonCallToAction = (props:ButtonProps) => {
    const { children, ...rest } = props;

    return (
      <Button btnType={styles.btnCallToAction} {...rest}>
        {children}
      </Button>
    );
};
